module.exports = __webpack_public_path__ + "static/media/e-donation.560d415a.txt";